"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.estimateGasLimit = exports.inferMaxFeePerGas = exports.inferMaxPriorityFeePerGas = exports.inferGasPrice = exports.getNetworkInfo = void 0;
var Ethereum_1 = require("../../api/Ethereum");
var transaction_1 = require("./transaction");
var range_1 = require("../../range");
var cache_1 = require("../../cache");
var env_1 = require("../../env");
var getNetworkInfo = function (currency) { return __awaiter(void 0, void 0, void 0, function () {
    var api, _a, low, medium, high, next_base, minValue, maxValue, initial, maxPriorityFeePerGas, nextBaseFeePerGas, gasPrice;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                api = (0, Ethereum_1.apiForCurrency)(currency);
                return [4 /*yield*/, api.getGasTrackerBarometer(currency)];
            case 1:
                _a = _b.sent(), low = _a.low, medium = _a.medium, high = _a.high, next_base = _a.next_base;
                minValue = low;
                maxValue = high.lte(low) ? low.times(2) : high;
                initial = medium;
                if ((0, transaction_1.EIP1559ShouldBeUsed)(currency)) {
                    maxPriorityFeePerGas = (0, range_1.inferDynamicRange)(initial, {
                        minValue: minValue,
                        maxValue: maxValue
                    });
                    nextBaseFeePerGas = next_base;
                    return [2 /*return*/, {
                            family: "ethereum",
                            maxPriorityFeePerGas: maxPriorityFeePerGas,
                            nextBaseFeePerGas: nextBaseFeePerGas
                        }];
                }
                gasPrice = (0, range_1.inferDynamicRange)(initial, {
                    minValue: minValue,
                    maxValue: maxValue
                });
                return [2 /*return*/, {
                        family: "ethereum",
                        gasPrice: gasPrice
                    }];
        }
    });
}); };
exports.getNetworkInfo = getNetworkInfo;
var inferGasPrice = function (tx, networkInfo) {
    var _a, _b, _c, _d;
    return tx.feesStrategy === "slow"
        ? (_a = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _a === void 0 ? void 0 : _a.min
        : tx.feesStrategy === "medium"
            ? (_b = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _b === void 0 ? void 0 : _b.initial
            : tx.feesStrategy === "fast"
                ? (_c = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _c === void 0 ? void 0 : _c.max
                : tx.gasPrice || ((_d = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.gasPrice) === null || _d === void 0 ? void 0 : _d.initial);
};
exports.inferGasPrice = inferGasPrice;
var inferMaxPriorityFeePerGas = function (tx, networkInfo) {
    var _a, _b, _c, _d;
    if (networkInfo.maxPriorityFeePerGas)
        return tx.feesStrategy === "slow"
            ? (_a = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _a === void 0 ? void 0 : _a.min
            : tx.feesStrategy === "medium"
                ? (_b = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _b === void 0 ? void 0 : _b.initial
                : tx.feesStrategy === "fast"
                    ? (_c = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _c === void 0 ? void 0 : _c.max
                    : tx.maxPriorityFeePerGas || ((_d = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.maxPriorityFeePerGas) === null || _d === void 0 ? void 0 : _d.initial);
};
exports.inferMaxPriorityFeePerGas = inferMaxPriorityFeePerGas;
var inferMaxFeePerGas = function (tx, priorityFeePerGas, networkInfo) {
    var _a;
    if (tx.maxFeePerGas)
        return tx.maxFeePerGas;
    var amplifiedBaseFee = (_a = networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.nextBaseFeePerGas) === null || _a === void 0 ? void 0 : _a.multipliedBy(2);
    return amplifiedBaseFee === null || amplifiedBaseFee === void 0 ? void 0 : amplifiedBaseFee.plus(priorityFeePerGas || 0);
};
exports.inferMaxFeePerGas = inferMaxFeePerGas;
exports.estimateGasLimit = (0, cache_1.makeLRUCache)(function (account, transaction) {
    var api = (0, Ethereum_1.apiForCurrency)(account.currency);
    return api
        .getDryRunGasLimit(transaction)
        .then(function (value) {
        return value.eq(21000) // regular ETH send should not be amplified
            ? value
            : value.times((0, env_1.getEnv)("ETHEREUM_GAS_LIMIT_AMPLIFIER")).integerValue();
    })["catch"](function () { return api.getFallbackGasLimit(transaction.to); });
}, function (account, _a) {
    var from = _a.from, to = _a.to, value = _a.value, data = _a.data;
    return "".concat(from, "+").concat(to, "+").concat(value, "+").concat(data);
});
exports["default"] = {
    getNetworkInfo: exports.getNetworkInfo,
    inferGasPrice: exports.inferGasPrice,
    inferMaxFeePerGas: exports.inferMaxFeePerGas,
    inferMaxPriorityFeePerGas: exports.inferMaxPriorityFeePerGas
};
//# sourceMappingURL=gas.js.map